import { render, staticRenderFns } from "./TciSlideBtnCard.vue?vue&type=template&id=78813836&scoped=true"
import script from "./TciSlideBtnCard.vue?vue&type=script&lang=js"
export * from "./TciSlideBtnCard.vue?vue&type=script&lang=js"
import style0 from "./TciSlideBtnCard.vue?vue&type=style&index=0&id=78813836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78813836",
  null
  
)

export default component.exports